<template>
  <md-chip
    :md-deletable="deletable"
    class="gl-chip"
    :class="classes"
    v-on="listerners"
  >
    <slot></slot>
  </md-chip>
</template>

<script>
export default {
  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    accent: {
      type: Boolean,
      default: false,
    },
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'md-primary': this.primary,
        'md-accent': this.accent,
      }
    },
    listerners() {
      return {
        ...this.$listeners,
        'md-delete': e => this.$emit('delete', e),
      }
    },
  },
}
</script>
